import { motion } from "framer-motion";

const LoadingSpinner = ({ absolute = false }) => {
    // console.log(absolute);
    return (
        <motion.div
            key="loading"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0, scale: 0.2, duration: 0.24 }}
            // style={absolute ? { top: "50%" } : ''}
            transition={{ duration: 0.3 }}
            className="loading-container"
        >
            <motion.div
                className="loading-spinner"
                animate={{ rotate: 360 }}
                transition={{ duration: 1, repeat: Infinity, ease: "easeInOut" }}
            />
        </motion.div>
    )
}

export default LoadingSpinner;